<template>
  <div class="text-danger control-error" v-if="error">
    <small>
      {{ error }}
    </small>
  </div>
</template>

<script>

  export default {
    name: "ValidationError",
    props: {
      error: [Boolean, String]
    }
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Partials/Controls/ValidationError.vue